import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
import { Input } from './Input';
import { Select } from './Select';
import { RichTextEditor } from './RichTextEditor';
interface AddPayoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (payout: {
    amount: number;
    date: string;
    customerId?: string;
    customerName?: string;
    notes?: string;
  }) => void;
  customers: Array<{
    id: string;
    customerId: string;
    name: string;
  }>;
}
export function AddPayoutModal({
  isOpen,
  onClose,
  onAdd,
  customers
}: AddPayoutModalProps) {
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [customerId, setCustomerId] = useState('');
  const [notes, setNotes] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!amount) return;
    const customer = customers.find(c => c.id === customerId);
    onAdd({
      amount: parseFloat(amount),
      date,
      customerId: customerId || undefined,
      customerName: customer?.name || undefined,
      notes: notes || undefined
    });
    // Reset form
    setAmount('');
    setDate(new Date().toISOString().split('T')[0]);
    setCustomerId('');
    setNotes('');
    onClose();
  };
  return <AnimatePresence data-id="element-203">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-204" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.3
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto" data-id="element-205">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 my-8" data-id="element-206">
              <div className="flex items-center justify-between mb-6" data-id="element-207">
                <h2 className="text-2xl font-semibold text-stone-900" data-id="element-208">
                  Tilføj udbetaling
                </h2>
                <button onClick={onClose} className="text-stone-400 hover:text-stone-600 transition-colors" aria-label="Luk" data-id="element-209">
                  <XIcon className="w-6 h-6" data-id="element-210" />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-211">
                <Input label="Beløb (kr)" type="number" step="0.01" value={amount} onChange={e => setAmount(e.target.value)} placeholder="f.eks. 5000" required data-id="element-212" />

                <Input label="Dato" type="date" value={date} onChange={e => setDate(e.target.value)} required data-id="element-213" />

                <Select label="Kunde (valgfri)" value={customerId} onChange={e => setCustomerId(e.target.value)} options={[{
              value: '',
              label: 'Ingen kunde'
            }, ...customers.map(c => ({
              value: c.id,
              label: `${c.name} (${c.customerId})`
            }))]} data-id="element-214" />

                <RichTextEditor label="Noter" value={notes} onChange={setNotes} placeholder="Tilføj noter om denne udbetaling" rows={3} data-id="element-215" />

                <div className="flex gap-3 pt-2" data-id="element-216">
                  <Button type="button" variant="secondary" onClick={onClose} className="flex-1" data-id="element-217">
                    Annuller
                  </Button>
                  <Button type="submit" variant="primary" className="flex-1" data-id="element-218">
                    Tilføj udbetaling
                  </Button>
                </div>
              </form>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}